module.exports = __webpack_public_path__ + "img/atp09.c32b294b.jpg";